(function () {
  'use strict';
  if (window.PapiroCartDesign) return;
  var APP = 'https://app.papiro.es';

  // La referencia de cada línea identifica su arte; nunca se usa el último
  // diseño del navegador ni una miniatura global compartida entre productos.
  function designs(value) {
    var result = [], seen = new Set();
    String(value || '').match(/https?:\/\/[^\s|<>"']+/g)?.forEach(function (raw) {
      try {
        var url = new URL(raw);
        if (url.origin !== APP || url.pathname !== '/api/designer/arte' || url.username || url.password || url.hash) return;
        var keys = [...url.searchParams.keys()];
        if (new Set(keys).size !== keys.length || keys.some(function (key) { return !['token', 'descarga', 'capa'].includes(key); })) return;
        var token = url.searchParams.get('token');
        if (!/^cart_[a-f0-9]{64}$/.test(token || '') || url.searchParams.get('descarga') !== '1') return;
        // La capa de corte no es otra tarjeta: sólo miniatura del arte impreso.
        if (url.searchParams.has('capa')) return;
        if (seen.has(token)) return;
        seen.add(token);
        result.push({ token: token, pdf: url.href, front: preview(token, 'frente'), back: preview(token, 'trasera') });
      } catch (_) { /* Los archivos aportados siguen en «Archivo adjunto». */ }
    });
    return result;
  }

  function preview(token, side) {
    return APP + '/api/designer/vista?token=' + encodeURIComponent(token) + '&cara=' + side + '&descarga=1';
  }

  function image(url, label) {
    var img = document.createElement('img');
    img.alt = label;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.referrerPolicy = 'no-referrer';
    img.src = url;
    return img;
  }

  function open(design, trigger, label) {
    document.querySelectorAll('dialog.papiro-cart-design-dialog').forEach(function (old) { old.close(); old.remove(); });
    var dialog = document.createElement('dialog');
    dialog.className = 'papiro-cart-design-dialog';
    dialog.setAttribute('aria-label', label);
    var heading = document.createElement('h2');
    heading.textContent = label;
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'papiro-cart-design-close';
    close.textContent = 'Cerrar';
    close.addEventListener('click', function () { dialog.close(); });
    var faces = document.createElement('div');
    faces.className = 'papiro-cart-design-faces';
    [['Delantera', design.front], ['Trasera', design.back]].forEach(function (entry) {
      var figure = document.createElement('figure'), caption = document.createElement('figcaption');
      caption.textContent = entry[0];
      var img = image(entry[1], entry[0] + ' de ' + label.toLowerCase());
      img.loading = 'eager';
      img.addEventListener('error', function () { img.remove(); caption.textContent = entry[0] + ': vista no disponible'; });
      figure.append(img, caption);
      faces.append(figure);
    });
    dialog.append(close, heading, faces);
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { dialog.remove(); if (trigger.isConnected) trigger.focus(); }, { once: true });
    document.body.append(dialog);
    dialog.showModal();
  }

  function render(root) {
    (root || document).querySelectorAll('[data-papiro-design]').forEach(function (row) {
      var source = row.dataset.papiroDesign || '', refs = designs(source);
      var attached = row.querySelector('[data-papiro-design-files]');
      if (attached && attached.dataset.source !== source) {
        attached.dataset.source = source;
        var links = [], seenFiles = new Set();
        String(source).match(/https?:\/\/[^\s|<>"']+/g)?.forEach(function (raw) {
          try {
            var url = new URL(raw);
            if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || seenFiles.has(url.href)) return;
            seenFiles.add(url.href);
            var link = document.createElement('a');
            link.href = url.href;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.className = 'papiro-file-link';
            link.textContent = seenFiles.size > 1 ? 'Ver archivo ' + seenFiles.size : 'Ver archivo';
            links.push(link);
          } catch (_) { /* Nunca construir enlaces con protocolos ejecutables. */ }
        });
        if (links.length) attached.replaceChildren(...links);
        else attached.textContent = 'Archivo adjunto';
      }
      var media = row.querySelector('.cart-items__media');
      if (!media) return;
      var signature = refs.map(function (ref) { return ref.token; }).join('|');
      if (media.dataset.papiroDesignRendered === signature) return;
      media.dataset.papiroDesignRendered = signature;
      media.querySelectorAll('.papiro-cart-designs').forEach(function (old) { old.remove(); });
      Array.from(media.children).forEach(function (child) {
        if (child.dataset.papiroDesignHidden === 'true') { child.hidden = false; delete child.dataset.papiroDesignHidden; }
      });
      if (!refs.length) return;
      var gallery = document.createElement('div');
      gallery.className = 'papiro-cart-designs';
      refs.forEach(function (ref, index) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'papiro-cart-design';
        var label = refs.length > 1 ? 'Tu diseño ' + (index + 1) : 'Tu diseño';
        card.setAttribute('aria-label', 'Ver ' + label.toLowerCase() + ', las dos caras');
        var img = image(ref.front, label), caption = document.createElement('span');
        caption.textContent = label;
        img.addEventListener('error', function () { img.hidden = true; caption.textContent = label + ' · vista no disponible'; });
        var flyer = Array.from(row.querySelectorAll('a[href*="/products/"]')).some(function (link) {
          return /^(Ofertas y novedades|Servicios y precios|Eventos|Programas y agendas|Turismo y visitas|Cuidados e instrucciones)\s*·/.test(link.textContent.trim());
        });
        if (flyer) {
          card.classList.add('papiro-cart-flyer');
          var scene = document.createElement('div'); scene.className = 'papiro-cart-flyer-scene';
          var reverse = image(ref.back, 'Trasera de tu flyer');
          reverse.className = 'papiro-cart-flyer-back'; img.className = 'papiro-cart-flyer-front';
          img.alt = 'Portada de tu flyer';
          reverse.addEventListener('error', function () { reverse.hidden = true; });
          scene.append(reverse, img); caption.textContent = 'Tu flyer · dos caras';
          card.append(scene, caption);
        } else card.append(img, caption);
        card.addEventListener('click', function () { open(ref, card, label); });
        gallery.append(card);
      });
      // La foto de catálogo nunca se presenta como si fuese el diseño comprado.
      Array.from(media.children).forEach(function (child) {
        if (!child.hidden) { child.hidden = true; child.dataset.papiroDesignHidden = 'true'; }
      });
      media.append(gallery);
    });
  }

  window.PapiroCartDesign = { designs: designs, render: render };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { render(); }, { once: true });
  else render();
})();
